<template lang="pug">
  v-app-bar(
    v-else
    app
    :value="!!topBar"
    flat
    :color="$theme.dark ? `black` : `white`")
    v-row(dense)
      v-col.shrink(
        v-arrow-transition="() => $route.name === `Search`")
        v-btn(
          @click='onClickPrevious'
          icon)
          v-icon {{ mdiChevronLeft }}
      v-col.pb-0
        v-form(@submit.prevent="onSubmit")
          v-text-field.grow.no-background(
            ref="textField"
            v-model="model"
            v-glass=".8"
            @focus="onFocus"
            hide-details
            solo
            flat
            label="Rechercher"
            clearable
            :append-icon="!model ? mdiMagnify : undefined"
            :name="Math.random()"
            :class="window.scrollY === 0 ? `elevation-1` : `elevation-4`")
</template>

<script>
import { noop } from 'lodash'
import { ref, computed, watch } from '@vue/composition-api'
import { mdiMagnify, mdiChevronLeft } from '@mdi/js'
import router, { routeCurrent } from '@iez/core/router'
import { model, search } from './search-page/'
import { state } from '../..'
import { page } from '@iez/core'
import data from '@iez/lib/data/'
import waitFor from '@iez/lib/wait-for/'
import gsap from 'gsap'
import useWindow from '@iez/lib/use-window'

export default {
  props: {
    topBar: Object
  },

  directives: {
    arrowTransition: {
      inserted: (element, { value: predicate }) => {
        let firstTime = true
        watch(
          predicate,
          value => {
            if (!value) {
              if (firstTime) {
                firstTime = false
                element.style.display = `none`
                return
              }
              element.style.display = ``
              gsap.to(
                element, {
                  width: 0,
                  paddingLeft: 0,
                  paddingRight: 0,
                  duration: .3,
                  onComplete: () => {
                    element.style.display = `none`
                    element.style.width = ``
                  }
                }
              )
            } else {
              element.style.display = ``
              const width = element.offsetWidth
              const {
                paddingLeft,
                paddingRight
              } = window.getComputedStyle(element)
              gsap.set(
                element, {
                  width: 0,
                  paddingLeft: 0,
                  paddingRight: 0
                }
              )
              gsap.to(
                element, {
                  width,
                  paddingLeft,
                  paddingRight,
                  duration: .3
                }
              )
            }
          }, {
            immediate: true
          }
        )
      }
    }
  },

  setup () {
    const textField = ref(null)

    const onFocus = () => {
      if (!model.value) {
        router.push({
          name: `Search`
        }).catch(noop)
      }
    }

    watch(
      () => routeCurrent.name,
      (currentValue, previousValue) => {
        if (previousValue === `Search`) {
          textField.value.blur()
        }
      }
    )

    watch(
      () => model.value,
      model => {
        if (!model && routeCurrent.params.query) {
          router.replace({
            name: `Search`
          })
        }
      }
    )

    const onClickPrevious = () => {
      model.value = ``
      router.back()
    }

    const onSubmit = () => {
      search()
    }
/* 
    page.bottomShortcut.add(
      () =>
        model.value && routeCurrent.params.query !== model.value
          ? {
            action: {
              icon: mdiMagnify,
              label: `Rechercher`,
              onClick: search
            }
          } : null
    ) */

    return {
      onFocus,
      mdiMagnify,
      model,
      mdiChevronLeft,
      onClickPrevious,
      onSubmit,
      textField,
      window: useWindow()
    }
  }
}
</script>

<style scoped>
>>> * .v-input__slot {
  box-shadow: none !important;
}
.v-input {
  transition: all .3s;
}
</style>
